import { render } from "./ChartColetaMensalPage.vue?vue&type=template&id=bfc4fdf6&scoped=true"
import script from "./ChartColetaMensalPage.vue?vue&type=script&lang=js"
export * from "./ChartColetaMensalPage.vue?vue&type=script&lang=js"

import "./ChartColetaMensalPage.vue?vue&type=style&index=0&id=bfc4fdf6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfc4fdf6"]])

export default __exports__